import { SocialPlatform } from '@app/modules/social-export/domain/platforms';
import { useQueryParam } from '@mi-front/core';
import { Alert, AlertTitle, Box } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { connectionsManageMessages as messages } from '../connections-manage-messages';

interface Props {
  platform: SocialPlatform;
}

/**
 * Success banner after OAuth / API-key connect redirects with connectResult=success
 * (shown on connection settings, and briefly on manage if the redirect has not run yet).
 */
export function ConnectionSuccessAlert({ platform }: Props) {
  const connectResult = useQueryParam('connectResult');

  if (connectResult !== 'success') {
    return null;
  }

  return (
    <Box sx={{ mb: 4 }}>
      <Alert severity="success">
        <AlertTitle>
          <FormattedMessage
            id="socialExport.connectionSuccess.title"
            defaultMessage="Conexión exitosa con {name}"
            values={{ name: platform.name }}
          />
        </AlertTitle>
        <FormattedMessage {...messages.connectionSuccessLinkStations} />
      </Alert>
    </Box>
  );
}
